import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  constructor(
    private translate: TranslateService,
    private router: Router,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    // Postavi default jezik
    this.translate.setDefaultLang('en');

    // Pokušaj koristiti jezik iz browsera ili localStorage
    const browserLang = this.translate.getBrowserLang();
    const savedLang = localStorage.getItem('language');

    if (savedLang) {
      this.translate.use(savedLang);
    } else if (browserLang && ['en', 'cro'].includes(browserLang)) {
      this.translate.use(browserLang);
    } else {
      this.translate.use('en');
    }

    this.checkForCalendarCallback();
  }

  private checkForCalendarCallback(): void {
    const params = new URLSearchParams(window.location.search);
    const calendarParam = params.get('calendar');

    if (!calendarParam) {
      return;
    }

    if (calendarParam === 'google-connected') {
      this.snackBar.open(
        this.translate.instant('client.calendarSettings.googleConnected') || 'Google Calendar connected successfully!',
        'Close',
        { duration: 4000, horizontalPosition: 'center', verticalPosition: 'top', panelClass: ['success-snackbar'] }
      );
    } else if (calendarParam === 'microsoft-connected') {
      this.snackBar.open(
        this.translate.instant('client.calendarSettings.microsoftConnected') || 'Microsoft Calendar connected successfully!',
        'Close',
        { duration: 4000, horizontalPosition: 'center', verticalPosition: 'top', panelClass: ['success-snackbar'] }
      );
    }

    const returnUrl = localStorage.getItem('calendarReturnUrl');
    localStorage.removeItem('calendarReturnUrl');

    if (returnUrl) {
      this.router.navigateByUrl(returnUrl);
    }
  }
}
